import ActivityHelper from '@/plugins/autosaver/activities/activity-helper.js';

const helper = new ActivityHelper();

export default {
    'ActivityTemplates/QUIZ_CONTENT': {
        fields: [
            'quiz_id',
            'review_allowed',
            'calculator_enabled',
            'show_answers_in_review',
            'show_provided_answers_in_review',
            'show_score_in_review',
            'show_correct_answers_in_review',
            'time_limit',
            'lockdown',
            'password_enabled',
            'force_start',
        ],
        callback: (store, mutation) => {
            helper.saveQuizActivity(store, mutation);
        },
    },

    'Activities/QUIZ_CONTENT': {
        fields: [
            'quiz_id',
            'review_allowed',
            'calculator_enabled',
            'show_answers_in_review',
            'show_provided_answers_in_review',
            'show_score_in_review',
            'show_correct_answers_in_review',
            'time_limit',
            'lockdown',
            'password_enabled',
            'force_start',
        ],
        callback: (store, mutation) => {
            helper.saveQuizActivity(store, mutation);
        },
    },
};
